import React, { Component, Fragment } from 'react';
import { Tabs, Tab,Paper } from '@material-ui/core';
import { withSnackbar } from 'notistack';
import { TableListComp, EmptyCollection, LicenseFailModal } from '../../../../shared_elements';
import { UpcomingShopVisit, ShopVisitHistory, AddEditShopVisit, NoUpcomingEvents, Claims } from '../../Elements';
import { getAssemblyEventListApi, getAssemblyUpcomingEventListApi, getAssemblyEventsApi, getClaimListApi, getMajorAssemblies } from '../../apiServices';
import { shopVisitObj, mntEventsHd } from '../../';
import { STableLoader } from '../../../../shared_elements/loaders';
import { permissionCheckFn } from '../../../../utils';
import { trackActivity } from '../../../../utils/mixpanel';
class LgAssembly extends Component {
  constructor(props){
    super(props);
    this.state = {
      tabIndex: 0,
      eventHistories: [],
      upcomingEvents: [],
      shopVisit: shopVisitObj,
      mntEvents: [],
      modal:false,
      skeletonLoader:true,
      pageLoader:false,
      claimsLoader:true,
      licenseModal:false,
      licenseModalMessage:'',
      claims:[],
      maList:[],
    }
    this.getAssemblyUpcomingEventListApi = getAssemblyUpcomingEventListApi.bind(this);
    this.getAssemblyEventListApi = getAssemblyEventListApi.bind(this);
    this.getAssemblyEventsApi = getAssemblyEventsApi.bind(this);
    this.getClaimListApi = getClaimListApi.bind(this);
    this.getMajorAssemblies = getMajorAssemblies.bind(this);
  }
  componentDidMount(){
    this.getAssemblyUpcomingEventListApi(this.props, 'lg');
    this.getAssemblyEventListApi(this.props, 'lg');
    this.getAssemblyEventsApi(this.props, 'lg');
    this.getClaimListApi(this.props, {asset_type:'lg'});
    this.getMajorAssemblies(this.props.match.params);

  }
  handleChange = (event, newValue) => {
    this.setState(prevState => ({
      ...prevState,
      tabIndex:newValue
    }))
  }
  toggleModalFn = (flag) => {
    this.setState({
      modal:flag
    })
  }
  onFieldChange = (event, keyParam, data) => {
    this.setState(prevState => ({
      ...prevState,
      shopVisit: {
        ...prevState.shopVisit,
        [keyParam]: data
      }
    }))
  }
  addEditShopVisit = () => {
    this.addEditLgShopVisitApi(this.props, this.state.shopVisit);
  }
  render(){
    const { tabIndex, eventHistories, upcomingEvents, mntEvents, skeletonLoader, pageLoader, claimsLoader, claims, licenseModal, licenseModalMessage  } = this.state;
    return(
      <div className="maintenance-module-section">
        <div className="maintenance-heads">
          <h3>Landing Gears</h3>
          <p>Section holds Maintenance claims of Landing Gears.</p>
        </div>
          <Paper className='maintenance-tabs'>
        <Tabs
          value={tabIndex}
          onChange={this.handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="normal"
          aria-label="full width tabs example"
        >
          <Tab label="Event History"
            onClick={() => trackActivity('Tab Clicked',
              {
                page_title: 'Landing Gear Tabs',
                asset_slug: this.props.match.params.assetSlug,
                asset_type: this.props.match.params.assetType,
                assembly_type: this.props.assemblyType,
                tab_name: 'Event History'
              })}
          />
          { permissionCheckFn( {secondaryKey:'upcoming_events', keyIndex:'R' }) ?
            <Tab label="Upcoming Events" onClick={() => trackActivity('Tab Clicked',
              {
                page_title: 'Landing Gear Tabs',
                asset_slug: this.props.match.params.assetSlug,
                asset_type: this.props.match.params.assetType,
                assembly_type: this.props.assemblyType,
                tab_name: 'Upcoming Events'
              })}
            />:null
          }
          { permissionCheckFn( {secondaryKey:'maintenance_claims', keyIndex:'R' }) ?
            <Tab label="Claims" onClick={() => trackActivity('Tab Clicked',
              {
                page_title: 'Landing Gear Tabs',
                asset_slug: this.props.match.params.assetSlug,
                asset_type: this.props.match.params.assetType,
                assembly_type: this.props.assemblyType,
                tab_name: 'Claims'
              })}
            />:null
          }
        </Tabs>
        </Paper>
        <div className="shop-visit-list">
          { tabIndex == 0 ? skeletonLoader ?  <STableLoader count={8} /> :
            <Fragment>
              {permissionCheckFn( {secondaryKey:'event_history', keyIndex:'C'}) ?
                <AddEditShopVisit 
                  maList={this.state.maList}
                  assemblyType='lg' 
                  buttonText="Add Shop Visit" 
                  mntEvents={mntEvents} 
                  getResponseBack={() => this.getAssemblyEventListApi(this.props, 'lg')} 
                  pageType="Add Shop Visit"
                  toggleLicenseFn={(modal, message) => this.setState({licenseModal:modal, licenseModalMessage:message})}
                /> : null
              }

              <TableListComp
                heads={mntEventsHd}
                data={eventHistories.map((item,index) =>
                  <ShopVisitHistory
                    key={index}
                    item={item}
                    viewDetail={() => this.props.history.push(`/${this.props.match.params.assetType}/${this.props.match.params.assetSlug}/maintenance/landing-gears/view/${item.id}`)}
                  />
                )}
                noRecord={eventHistories.length ? null : <EmptyCollection title="No records found" /> }
              />
          </Fragment> : null
          }
          { tabIndex == 1 ?  pageLoader ? <STableLoader count={4} /> :
            <div className="">
              { upcomingEvents.length ?
                <div>
                  {upcomingEvents.map((item, index) =>
                    <UpcomingShopVisit item={item} key={index} />
                  )}
                </div>:
                <NoUpcomingEvents />
              }
            </div> : null
          }
          { tabIndex == 2 ? claimsLoader ? <STableLoader count={6} /> :
            <div>
              <Claims claims={claims} skeletonLoader={false} props={this.props} />
            </div> : null
          }
        </div>
        <LicenseFailModal licenseModalMessage={licenseModalMessage} licenseModal={licenseModal}  toggleModalFn={() =>  this.setState({licenseModal:false, licenseModalMessage:'', })} />
      </div>
    )
  }
}
export default withSnackbar(LgAssembly);
